// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__3w0lI","circleTime":"styles_circleTime__3hBqH","box":"styles_box__3c_3s"};